module.exports = __webpack_public_path__ + "static/media/negative_event_response.949d8992.png";